import React from 'react';
import { Button } from "react-bootstrap";
import { useAuth } from "../../contexts/session_context";

const CardupdatrButton = (props : {ariaHidden? : boolean, role?: string, className?: any, text: string | any[], style?: any, id?: string, onClick?: any, disabled?: boolean, type?: "button" | "submit" | "reset"}) : JSX.Element => {

  let styleObject;
  const { app_configuration } = useAuth();
  if(app_configuration){
    const { app_configuration} = useAuth();
    styleObject = Object.assign({borderColor : app_configuration.button_color, backgroundColor : app_configuration.button_color, borderRadius : app_configuration.button_border_radius, padding : app_configuration.button_padding}, props.style);
  }
  else{
    styleObject = props.style;
  }

  return <Button aria-hidden={props.ariaHidden} role={props.role} type={props.type} style={styleObject} id={props.id} onClick={props.onClick} disabled={props.disabled} className={"cardupdatr-button btn btn-primary"}>{props.text}</Button>;
};

export default CardupdatrButton;